import { Link } from "react-router-dom";

export default function Registration() {
  return (
    <section id="inscribirse" className="w-full px-4 md:px-8 lg:px-12 py-8 md:py-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        {/* Online registration */}
        <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full border border-primary-500 flex items-center justify-center">
              <i className="ri-globe-line text-primary-500 text-sm" />
            </div>
            <span className="text-xs text-primary-500 font-semibold tracking-wider uppercase">
              Recomendado
            </span>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide mb-1">
            ¡INSCRÍBETE ONLINE
          </h2>
          <h2 className="font-heading text-3xl md:text-4xl text-primary-500 tracking-wide mb-4">
            EN MENOS DE 3 MINUTOS!
          </h2>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            Rápido y sin complicaciones. Asegura tu cupo inmediatamente desde tu computadora o celular.
          </p>

          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3">
              <i className="ri-user-line text-primary-500" />
              <span className="text-sm text-foreground-700">Elige tu categoría (Sub16, Sub20, Adultos).</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-file-list-3-line text-primary-500" />
              <span className="text-sm text-foreground-700">Completa tus datos y paga.</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-primary-500" />
              <span className="text-sm text-foreground-700">Recibe confirmación instantánea.</span>
            </div>
          </div>

          <Link
            to="/inscribirse"
            className="inline-flex items-center justify-center gap-2 w-full px-6 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            IR AL FORMULARIO ONLINE
            <i className="ri-arrow-right-line" />
          </Link>

          <p className="text-xs text-foreground-400 text-center mt-4">
            Precio: <strong className="text-foreground-700">$20</strong> - Incluye kit corredor oficial, medalla, camiseta, chip y dorsal
          </p>
        </div>

        {/* WhatsApp registration */}
        <div className="bg-foreground-950 rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full border border-accent-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-accent-500 text-sm" />
            </div>
            <span className="text-xs text-accent-500 font-semibold tracking-wider uppercase">
              Asistido
            </span>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl text-white tracking-wide mb-1">
            ¿PREFIERES AYUDA?
          </h2>
          <h2 className="font-heading text-3xl md:text-4xl text-accent-500 tracking-wide mb-4">
            HAZLO POR WHATSAPP
          </h2>

          <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6">
            Un asesor te guiará paso a paso. Ideal si necesitas realizar consultas específicas antes de pagar.
          </p>

          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3">
              <i className="ri-smartphone-line text-accent-500" />
              <span className="text-sm text-foreground-300">Envía tus datos por chat.</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-bank-card-line text-accent-500" />
              <span className="text-sm text-foreground-300">Recibe los datos para transferencia.</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-accent-500" />
              <span className="text-sm text-foreground-300">Envía comprobante y confirma.</span>
            </div>
          </div>

          <a
            href="https://wa.me/593979102532"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 w-full px-6 py-3 rounded-full bg-white text-foreground-950 font-semibold hover:bg-background-50 transition-colors whitespace-nowrap"
          >
            ABRIR WHATSAPP
            <i className="ri-external-link-line" />
          </a>

          <p className="text-xs text-foreground-400 text-center mt-4">
            WhatsApp oficial: <strong className="text-foreground-300">097 910 2532</strong>
          </p>
        </div>
      </div>
    </section>
  );
}